
import { FirearmAssignmentTypeInfoBase } from './firearm-assignment.typeinfo.base';


export class FirearmAssignmentTypeInfo extends FirearmAssignmentTypeInfoBase {
  name = 'Firearm Asset Assignment';
}

export const FIREARM_ASSIGNMENT_TYPE: FirearmAssignmentTypeInfo = new FirearmAssignmentTypeInfo();



